import React from 'react'
import Header from '../component/Header'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CommonBanner from '../component/CommonBanner'
import Footer from '../component/Footer'


function Help() {
  const helpTopics = [
    { title: 'Landlords', path: '/' },
    { title: 'Agents', path: '/' },
    { title: 'Lenders', path: '/' },
    { title: 'Homeowners', path: '/' },
    { title: 'Homebuyers', path: '/' },
    { title: 'Renters', path: '/' },
    { title: 'Home Sellers', path: '/' },
    { title: 'Privacy', path: '/' },
    { title: 'Homeloans', path: '/' }
  ]
  return (
    <>
      <div className='main help-page'>
        <Header/>
        <CommonBanner title="Help Centre" />
        <section className="help-topics-section common-padding">
          <Container>
            <Row className="g-4">
              {helpTopics.map((topic, index) => (
                <Col lg={4} md={6} sm={6} key={index}>
                  <Card className="help-topic-card">
                    <Card.Body>
                      <Link to={`/help-list`} className="topic-link">
                        <h5>{topic.title}</h5>
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  )
}
export default Help


